import { Component, OnInit } from '@angular/core';
import { RegService } from '../../shared/Reg.Service';
import { AppInsightsService } from '../../shared/AppInsights.Service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-step-three',
  templateUrl: './step-three.component.html',
  styleUrls: ['./step-three.component.scss']
})
export class StepThreeComponent implements OnInit {
  public isCes: boolean = false;
  public isEqh: boolean = false;
  public email = '';
  public name = '';
  public address1 = '';
  public address2 = '';
  public resp: any;
  public url = '';
  constructor(private regService: RegService, private appInsightsService: AppInsightsService,
    private router: Router) {
      if(this.router.url.indexOf('ces') !== -1){
        this.isCes = true;
      }else{
        this.isEqh = true;
      }
     }

  ngOnInit() {
  	window.scroll(0,0);
  	this.appInsightsService.logEvent("Client Registration UI Step Three");
    this.regService.loadData().subscribe(res => {
      this.resp = res;
      if (this.resp) {
        if (this.resp.status_code !== '200') {

        } else {
          this.email = this.resp.newEmail;
          this.name = this.resp.name;
          this.address1 = this.resp.address1;
          this.address2 = this.resp.address2;
          console.log('url ' + this.resp.url);
          this.url = this.resp.url;
        }
      }
    });

  }

  complete() {
    window.location.href = window.location.origin + this.url;
  }
}
